import React from "react";

const Bin = ({ style }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24.602"
      height="32"
      viewBox="0 0 24.602 32"
      stroke="currentColor"
      style={style}
    >
      <g id="Raggruppa_439" transform="translate(-254.922 -439.509)">
        <g id="Raggruppa_439-2">
          <line
            id="Linea_141"
            x2="22.602"
            transform="translate(255.923 444.509)"
            fill="none"
            strokeLinecap="round"
            strokeWidth="2"
          />
          <rect
            id="Rettangolo_215"
            width="10.464"
            height="4"
            rx="0.85"
            transform="translate(262.331 440.509)"
            fill="none"
            strokeLinecap="round"
            strokeWidth="2"
          />
        </g>
        <g id="Raggruppa_440">
          <path
            id="Tracciato_111"
            d="M257.769,447.594v17.915a5,5,0,0,0,5,5h9.909a5,5,0,0,0,5-5V447.594"
            fill="none"
            strokeLinecap="round"
            strokeWidth="2"
          />
        </g>
        <line
          id="Linea_142"
          y1="18"
          transform="translate(262.331 448.509)"
          fill="none"
          strokeLinecap="round"
          strokeWidth="2"
        />
        <line
          id="Linea_143"
          y1="18"
          transform="translate(272.795 448.509)"
          fill="none"
          strokeLinecap="round"
          strokeWidth="2"
        />
        <line
          id="Linea_144"
          y1="18"
          transform="translate(267.563 448.509)"
          fill="none"
          strokeLinecap="round"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
};

export default Bin;
